<template>
    <div ref="popup" class="llp-popup modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header d-block border-0">
                    <h5 class="modal-title text-center" v-html="title"></h5>
                </div>
                <div class="modal-body">
                    <div class="row text-center" v-html="body"></div>
                </div>
                <div class="modal-footer d-block border-0">
                    <div :class="isConfirmPopup? 'justify-content-center' : ' justify-content-between'" class="row">
                        <div class="col-auto">
                            <button class="btn btn-outline-primary text-uppercase" data-bs-dismiss="modal" name="cancel"
                                    type="button" @click="clickCancelButton">
                                {{ isConfirmPopup ?  "OK" : "NO" }}
                            </button>
                        </div>
                        <div v-if="!isConfirmPopup" class="col-auto">
                            <button :class="rightButtonClassNames" class="btn text-uppercase"
                                    data-bs-dismiss="modal"
                                    name="confirm" type="button" @click="clickConfirmButton">{{
                                   "Yes"
                                }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Modal} from 'bootstrap';

export default {
  name: 'BasePopup',
  data: function() {
    return {
      dataType: '',
      callBack: Function,
      cancelCallback: Function,
      title: '',
      body: '',
      rightButtonClassNames: '',
      isConfirmPopup: false,
    };
  },
  methods: {
    showPopup(title, body, callBack, type, cancelCallback) {
      let rightButtonClassNames = '';
      if (!title) {
        return;
      }
      if (!body) {
        return;
      }
      this.title = title;
      this.body = body;
      this.isConfirmPopup = false;

      switch (type) {
        case 'info':
          rightButtonClassNames = 'btn-primary';
          break;
        case 'confirm':
          this.isConfirmPopup = true;
          break;
        case 'delete':
        default:
          rightButtonClassNames = 'btn-danger';
          break;
      }

      this.rightButtonClassNames = rightButtonClassNames;

      let popup = new Modal(this.$refs.popup);
      popup.show();
      this.callBack = callBack;
      this.cancelCallback = cancelCallback;
    },
    clickConfirmButton() {
      if (typeof this.callBack === 'function') {
        this.callBack();
      }
    },
    clickCancelButton() {
      if (typeof this.cancelCallback === 'function') {
        this.cancelCallback();
      }
    },
  },
};
</script>
